window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );
  const compareBtns = [...window.document.body.querySelectorAll('.product .compare-button-wrap')];
  const compareCounts = [...window.document.body.querySelectorAll('.product .countPill')];

  compareCounts.forEach((e) => (e.textContent = productsIdsToCompare.length));
  compareBtns.forEach((e) => {
    if (productsIdsToCompare.includes(e.id) && productsIdsToCompare.length > 1) {
      e.style.visibility = 'visible';
      e.style.display = 'block';
    } else {
      e.style.visibility = 'hidden';
      e.style.display = 'none';
    }
    e.childNodes[0].href = `/compare/${productsIdsToCompare.join('/')}/`;
  });
};

const inchFields = ['Width', 'Height', 'Depth'];
const poundFields = ['Weight'];
window.Convermax.getFieldUnit = (field) => {
  if (inchFields.includes(field)) {
    return '"';
  }
  if (poundFields.includes(field)) {
    return ' lb';
  }

  return '';
};

export default {
  platform: 'bigcommerce',
  page: {
    getPageType: (defaults) =>
      window.document.querySelector('.page.page--brand')
        ? 'brand'
        : window.document.querySelector('.page.page--category')
          ? 'category'
          : defaults.getter(),
  },
  SearchRequestDefaults: {
    pageSize: 48,
  },
  facets: {
    rangedFacet: [{ fields: [...inchFields, ...poundFields], step: '1/100' }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategorySearchPage',
      type: 'SearchPage',
      location: '.page--category #product-listing-container',
      template: 'SearchPage',
      visibleIf: () => !window.document.querySelector('.page--category #faceted-search-container nav'),
    },
    { name: 'FacetPanel', ignoreFields: ['sale_categories'] },
    {
      name: 'SearchPageCategory',
      type: 'SearchPage',
      location: {
        selector: ['.page--category #product-listing-container', '.page--brand #product-listing-container'],
        class: 'cm_main-content',
      },
      template: 'MainContent',
      visibleIf: { selector: '#faceted-search-container nav' },
    },
    {
      name: 'FacetPanelBrand',
      type: 'FacetPanel',
      location: { selector: '.page--brand #faceted-search-container nav' },
      template: 'FacetPanelContainer',
    },
    {
      name: 'FacetPanelCategory',
      type: 'FacetPanel',
      location: { selector: '.page--category #faceted-search-container nav' },
      template: 'FacetPanelContainer',
      ignoreFields: window.location.pathname === '/sale/' && ['category'],
    },
    {
      name: 'SearchBox',
      location: { selector: '.quickSearchWrap', class: 'cm_mobile-hide' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertBefore: '.body>.container',
        class: 'cm_search-box-root__mobile-container cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'SearchBoxDialogButtonCategories',
      type: 'SearchBoxDialogButton',
      location: {
        insertBefore: '.page--category>.container',
        class: 'cm_search-box-root__mobile-container cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
      sortEntries: {
        'relevance': 'Best Match',
        'name': 'A to Z',
        'name:desc': 'Z to A',
        'price': 'Price: Ascending',
        'price:desc': 'Price: Descending',
        'review_score:desc': 'Customer Review',
      },
    },
    { name: 'SearchResult' },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};
